import { render, staticRenderFns } from "./HiClickable.vue?vue&type=template&id=527bbb82&scoped=true&"
import script from "./HiClickable.vue?vue&type=script&lang=js&"
export * from "./HiClickable.vue?vue&type=script&lang=js&"
import style0 from "./HiClickable.vue?vue&type=style&index=0&id=527bbb82&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527bbb82",
  null
  
)

export default component.exports